const de = {
  title: { awpm: 'AWPM-Wahlübersicht', fwpm: 'FWPM-Wahlübersicht' },
  createSelection: 'Neue Wahl',
  activeTab: 'Aktiv',
  inactiveTab: 'Inaktiv',
  archiveTab: 'Archiv',
  draftTab: 'Entwurf',
  failedLoading: 'Laden der Modulwahlen fehlgeschlagen.',
  noSelections: 'Keine Modulwahlen gefunden',
  condition: 'Zustand',
  filter: {
    search: 'Suchen...',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    courseOfStudy: 'Studiengänge',
    courseOfStudyQuickInfo:
      'Sie können hier mehrere Studiengänge wählen. Dann werden alle Wahlen angezeigt, welche sich auf mindestens einen der gewählten Studiengänge beziehen.',
    mySelections: 'Meine Wahlen'
  },
  sort: {
    nameAsc: 'Name aufsteigend',
    nameDesc: 'Name absteigend'
  },
  dischargeStudentsUntil: 'Austragbar durch Studenten',
  createdBy: 'Erstellt von',
  participants: 'Weitere Teilnehmer',
  startEmailNotification: 'E-Mail Benachrichtigung starten',
  useAsTemplate: 'Als Vorlage verwenden',
  viewOccupancy: 'Belegung ansehen',
  global: 'Fächerübergreifend',
  createModalTitle: { awpm: 'Neue AWPM-Modulwahl', fwpm: 'Neue FWPM-Modulwahl' },
  editModalTitle: 'Modulwahl bearbeiten',
  createModalTemplateTitle: 'Wahl als Vorlage wiederverwenden',
  create: {
    saveDraft: 'Entwurf speichern',
    steps: {
      generalInfo: 'Allgmeine Angaben',
      periodsAndExtraInfo: 'Zeiträume & Angaben'
    },
    generalInfo: {
      title: 'Titel',
      generalNotes: 'Allgemeine Hinweise',
      electionTip: 'Wahltipps',
      attachments: 'Anhänge',
      viewer: 'Beobachtende Rollen',
      tooltips: {
        viewingRoles:
          'Personen mit einer der ausgewählten Rollen dürfen die Wahl sehen, jedoch mit lesendem Zugriff.'
      },
      organizingPersons: 'Weitere Beobachter'
    },
    periodsAndExtraInfo: {
      electionTimeframe: 'Wahlzeitraum',
      startDate: 'Startzeitpunkt',
      endDate: 'Endzeitpunkt',
      extraTimeframes: 'Sonstige Zeiträume',
      dischargeByStudentsUntil: 'Austragung durch Studenten bis',
      contentVisibleFrom: 'Inhalte sichtbar ab',
      maxSelectedModules: 'Max. belegbare Module',
      lengthOfTheWishlist: 'Länge der Wunschliste',
      activeInAllCommunities: 'Aktiv in allen Communities'
    },
    alerts: {
      saveFailed: 'Erstellung der Modulwahl fehlgeschalgen.',
      editFailed: 'Bearbeiten der Modulwahl fehlgeschlagen.',
      saveSuccessful: 'Modulwahl erfolgreich erstellt',
      editSuccessful: 'Modulwahl erfolgreich bearbeitet',
      createFromTemplateSuccessful: 'Modulwahl erfolgreich von Vorlage erstellt',
      createFromTemplateFailed: 'Modulwahl konnte nicht von Vorlage erstellt werden.'
    }
  },
  allocation: {
    listHeaders: {
      minParticipants: 'Min TN',
      maxParticipants: 'Max TN',
      countParticipants: 'Anzahl TN',
      countWaitinglist: 'Anzahl WL'
    }
  },
  states: {
    dischargable: 'Nachrückverfahren',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    completed: 'Abgeschlossen',
    draft: 'Entwurf',
    archived: 'Archiviert',
    started: 'Gestartet'
  }
};

export default de;
export type ModuleSelectionsTranslation = typeof de;
